import { useContext, useEffect } from 'react';
import { LayoutContext } from '../contexts/LayoutContext';
import ReviewList from '../components/Review/ReviewList';

function ReviewPage() {
  const { setIsContentScrollable } = useContext(LayoutContext);

  useEffect(() => {
    setIsContentScrollable(false);
    return () => { setIsContentScrollable(true); };
  }, [setIsContentScrollable]);

  return <ReviewList />;
}

export default ReviewPage;
